"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
function default_1(props) {
    const { confirm, whoAmI, paytype, isLeaderBlocked } = props;
    const isAdultOnly = paytype === 'adult_only';
    const isAdultPlus = paytype === 'adult_plus';
    const isUserLoggedIn = whoAmI.is_logged_in;
    const isUserCertified = whoAmI.is_certified;
    const isUserUnder19 = whoAmI.is_under_19;
    const commonDescription = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('19세 이상 성인만 참여할 수 있어요.')] }));
    if (isAdultOnly || isAdultPlus) {
        if (!isUserLoggedIn) {
            confirm({
                description: commonDescription,
                confirmationText: i18next_1.default.t('로그인'),
                cancellationText: i18next_1.default.t('홈으로 이동'),
                allowClose: false,
            })
                .then(() => window.location.replace((0, string_utils_1.loginReturnPath)()))
                .catch(functions_1.replaceToMain);
            (0, functions_1.preventDOMChange)();
            return false;
        }
        if (isUserLoggedIn && !isUserCertified) {
            confirm({
                description: commonDescription,
                confirmationText: i18next_1.default.t('본인인증'),
                cancellationText: i18next_1.default.t('홈으로 이동'),
                allowClose: false,
            })
                .then(() => window.location.replace(`/member/setting?from=${window.location.pathname}${window.location.search}`))
                .catch(functions_1.replaceToMain);
            (0, functions_1.preventDOMChange)();
            return false;
        }
        if (isUserUnder19) {
            confirm({
                description: commonDescription,
                cancellationButtonProps: { style: { display: 'none' } },
                allowClose: false,
            })
                .then(functions_1.replaceToMain)
                .catch(functions_1.replaceToMain);
            (0, functions_1.preventDOMChange)();
            return false;
        }
    }
    if (isLeaderBlocked) {
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님의 차단으로 폼을 참여할 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('실수가 있을 수 있으니'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('해제는 작가님께 문의해주세요.')] })),
            cancellationButtonProps: { style: { display: 'none' } },
            allowClose: false,
        });
        return 'leaderBlocked';
    }
    return true;
}
exports.default = default_1;
